<script setup lang="ts">
const { page } = useContent()

watch(
  () => page.value,
  (p) => {
    if (p) useContentHead(p)
  },
  { immediate: true },
)
</script>

<template>
  <div>
    <slot />
  </div>
</template>
